import { createRoot, hydrateRoot } from "react-dom/client";
import App from "./App";
import type { InitialData } from "./lib/initial-data";
import "./index.css";

const container = document.getElementById("root")!;
const ssrRendered = (window as unknown as { __SSR__?: boolean }).__SSR__;
const initialData = (
  window as unknown as { __INITIAL_DATA__?: InitialData }
).__INITIAL_DATA__;

if (ssrRendered && container.hasChildNodes()) {
  hydrateRoot(container, <App initialData={initialData} />);
} else {
  createRoot(container).render(<App initialData={initialData} />);
}
